import React, { useEffect } from "react";
import Navbar from "./Component/Navbar";
import Footer from "./Component/Footer";
import BusinessAppSection from "./Component/IP/BusinessAppSection";
import BusinessOpportunity from "./Component/IP/BusinessOpportunity";
import FeaturesSection from "./Component/IP/FeaturesSection";
import Testimonial from "./Component/IP/Testimonial";
import ReadyToStart from "./Component/IP/ReadyToStart";
import FAQSection from "./Component/FAQSection";
import LeftFeature from "./Component/useEnyWhere/LeftFeature"; // Import the FeatureSection component
import RightFeature from "./Component/useEnyWhere/RightFeature"; // Import the FeatureSection component
import AOS from "aos";
import "aos/dist/aos.css"; // Import the AOS styles

const IpLandingPage = () => {
  useEffect(() => {
    AOS.init({
      offset: 120,

      duration: 1000, // Set the duration of the animation
      easing: "ease-in-out", // Set the easing function
      once: false, // Animation will run only once
    });
  }, []);
  return (
    <div>
      <BusinessOpportunity />
      <BusinessAppSection />
      {/* <Feature /> */}
      {/* <div className="max-w-6xl mx-auto text-center m-12">
        <h3 className="text-md uppercase tracking-widest text-gray-500 mb-2">
        Packed with powerful features         </h3>
        <h2 className="text-4xl font-bold">
        A whole lot more than just sending money.        </h2>
      </div>
        <LeftFeature
          title="Get a Dedicated Key Account Manager (KAM)"
          description=
"Our innovative solutions provide a clear direction, helping you streamline workflows, organize tasks effortlessly, & achieve unparalleled efficiency. Let Zenify Navigator be your compass on the journey to intelligent & effective business management."
          features={[
            "Intuitive Task Organization",
            "Customizable Dashboards",
            "User Training and Support",
          ]}
          imageSrc="/assests/images/LandingPage/IP/feature1.png"
          imageAlt="Team discussion"
        />

<RightFeature
          title="Get a Dedicated Key Account Manager (KAM)"
          description=
          "Our innovative solutions provide a clear direction, helping you streamline workflows, organize tasks effortlessly, & achieve unparalleled efficiency. Let Zenify Navigator be your compass on the journey to intelligent & effective business management."

          features={[
            "Intuitive Task Organization",
            "Customizable Dashboards",
            "User Training and Support",
          ]}
          imageSrc="/assests/images/LandingPage/IP/feature2.png"
          imageAlt="Team discussion"
        /> */}
      {/* <FeaturesSection /> */}
      <Testimonial />
      <ReadyToStart />
      {/* <FAQSection /> */}
    </div>
  );
};
export default IpLandingPage;
